import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import { colors, Typography } from '@sweep-io/sweep-design';
import {
  Delete,
  PaintBucket,
  RelatedObjects,
  Smile,
  ChevronRight,
  UsedBy,
} from '@sweep-io/sweep-design/dist/icons';
import { SfIconsDialog } from '../../../../../common/sf-icons-dialog/SfIconsDialog';
import { useState } from 'react';
import { ColorPicker } from '../../../../../common/color-picker/ColorPicker';
import { useFeatureToggle } from '../../../../../../feature-flags/useFeatureToggle';

export const MetadataMorePanel = ({
  anchorEl,
  handleClose,
  isOpen,
  onIconChange,
  onColorChange,
  selectedColor,
  onRemoveClick,
  currentIcon,
  onDependenciesClick,
  onUsedByClick,
}: {
  anchorEl: (EventTarget & Element) | null;
  handleClose: () => void;
  isOpen: boolean;
  onIconChange: (icon: string | null) => void;
  onColorChange: (color: string) => void;
  onRemoveClick: () => void;
  selectedColor?: string;
  currentIcon?: string | null;
  onDependenciesClick: (e: React.MouseEvent<HTMLLIElement>) => void;
  onUsedByClick: (e: React.MouseEvent<HTMLLIElement>) => void;
}) => {
  const [isIconDialogOpen, setIsIconDialogOpen] = useState(false);
  const [colorPopoverRef, setColorPopoverRef] = useState<(EventTarget & HTMLLIElement) | null>(
    null,
  );
  const { usedByInMetadataElements } = useFeatureToggle();
  return (
    <>
      <Menu
        anchorEl={anchorEl}
        open={isOpen}
        onClose={handleClose}
        sx={{
          '& .MuiListItemIcon-root': {
            minWidth: '16px !important', // TODO: Properly fix this. Something is overriding the minWidth to 32px
          },
          '& .MuiMenuItem-root': {
            gap: '8px',
          },
        }}
      >
        <MenuItem onClick={() => setIsIconDialogOpen(true)}>
          <ListItemIcon>
            <Smile size="medium" />
          </ListItemIcon>
          <ListItemText>
            <Typography variant="body">{currentIcon ? 'Change Icon' : 'Add Icon'}</Typography>
          </ListItemText>
        </MenuItem>
        <MenuItem onClick={(e) => setColorPopoverRef(e.currentTarget)}>
          <ListItemIcon>
            <PaintBucket size="medium" />
          </ListItemIcon>
          <ListItemText>
            <Typography variant="body">Change Color</Typography>
          </ListItemText>
        </MenuItem>
        <MenuItem onClick={onDependenciesClick} sx={{ minWidth: '236px' }}>
          <ListItemIcon>
            <RelatedObjects size="medium" />
          </ListItemIcon>
          <ListItemText>
            <Typography variant="body">Add Dependencies</Typography>
          </ListItemText>
          <ChevronRight size="medium" />
        </MenuItem>
        {usedByInMetadataElements && (
          <MenuItem onClick={onUsedByClick} sx={{ minWidth: '236px' }}>
            <ListItemIcon>
              <UsedBy size="medium" />
            </ListItemIcon>
            <ListItemText>
              <Typography variant="body">Add Used By</Typography>
            </ListItemText>
            <ChevronRight size="medium" />
          </MenuItem>
        )}
        <MenuItem onClick={onRemoveClick}>
          <ListItemIcon>
            <Delete color={colors.feedback.destructive} size="medium" />
          </ListItemIcon>
          <ListItemText>
            <Typography variant="body" color={colors.feedback.destructive}>
              Remove
            </Typography>
          </ListItemText>
        </MenuItem>
      </Menu>

      <SfIconsDialog
        open={isIconDialogOpen}
        onClose={() => setIsIconDialogOpen(false)}
        onSelect={(iconName) => {
          onIconChange(iconName);
          setIsIconDialogOpen(false);
          handleClose();
        }}
        onRemove={() => {
          onIconChange(null);
          setIsIconDialogOpen(false);
          handleClose();
        }}
        showRemoveIcon={!!currentIcon}
      />
      {colorPopoverRef && (
        <ColorPicker
          anchorElement={colorPopoverRef}
          closePopover={() => setColorPopoverRef(null)}
          onColorChange={onColorChange}
          selectedColor={selectedColor}
        />
      )}
    </>
  );
};
